import { Component, Input } from '@angular/core';

import { Task } from 'app/shared/models/task.model';

@Component({
  selector: 'task-popout',
  templateUrl: './task-popout.component.html'
})

/**
 * Component for wrapping Task Details in a model view.
 */
export class TaskPopoutComponent {
    @Input() task: Task;
}



// WEBPACK FOOTER //
// ./src/app/task/taskpopout/task-popout.component.ts